import { Box, Grid2, Tooltip, Typography } from "@mui/material";
import { MainContent } from "IF/interfaceType";
import SignalCellularAltIcon from "@mui/icons-material/SignalCellularAlt";
import SignalCellularOffIcon from "@mui/icons-material/SignalCellularOff";

export const AlertAreaStatus = ({ panel }: { panel: MainContent }) => {
  // アラートの回数
  const alertNum = panel.alertDataList.length;

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          maxWidth: "100%",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          p: 1,
          pt: 0,
          gap: 1,
        }}
      >
        <Tooltip
          title={
            <span>
              シリアルNo：{panel.serialNo}
              <br />
              エリア名：{panel.name}
            </span>
          }
          arrow
        >
          <>
            <Grid2
              container
              direction="row"
              sx={{
                display: { xs: "none", sm: "none", md: "block" },
              }}
            >
              <Grid2
                style={{
                  textAlign: "left",
                }}
              >
                <Typography
                  fontWeight="fontWeightBold"
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  シリアルNo：{panel.serialNo}
                </Typography>
              </Grid2>
              <Grid2>
                <Typography
                  fontWeight="fontWeightBold"
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  エリア名：{panel.name}
                </Typography>
              </Grid2>
            </Grid2>
            <Grid2
              container
              direction="row"
              sx={{ display: { xs: "block", sm: "block", md: "none" } }}
            >
              <Grid2
                style={{
                  textAlign: "left",
                }}
              >
                <Typography
                  fontWeight="fontWeightBold"
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  No.{panel.serialNo}
                </Typography>
              </Grid2>
              <Grid2>
                <Typography
                  fontWeight="fontWeightBold"
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {panel.name}
                </Typography>
              </Grid2>
            </Grid2>
          </>
        </Tooltip>
        <Grid2
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: panel.aliveFlg
              ? "linear-gradient(45deg, #4caf50, #2e7d32)"
              : "linear-gradient(45deg, #9e9e9e, #616161)",
            borderRadius: 2,
            minWidth: "80px",
            maxHeight: "35px",
            padding: "6px 12px",
            boxShadow: 3,
          }}
        >
          {panel.aliveFlg ? (
            <SignalCellularAltIcon sx={{ color: "white", mr: 0.5 }} />
          ) : (
            <SignalCellularOffIcon sx={{ color: "white", mr: 0.5 }} />
          )}
          <Typography
            variant="subtitle1"
            fontWeight="bold"
            noWrap
            color="white"
          >
            {panel.aliveFlg ? "通信中" : "通信不可"}
          </Typography>
        </Grid2>
      </Box>

      <Box fontWeight="fontWeightBold">
        <Box
          sx={{
            color: alertNum > 0 ? "red" : "green",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "100%",
            p: 1,
          }}
          className="alert-status-box"
        >
          <Box>{alertNum} 回</Box>
          {alertNum > 0 && (
            <img
              src="/images/警告.png"
              alt="警告"
              style={{ width: "60px", height: "auto" }}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default AlertAreaStatus;
